// JavaScript source code
import React, { useState, useEffect, useRef} from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
import LeftNav from '../components/leftnav';
import LoginDialog from '../components/loginDialog';
import LoadingOverlay from '../components/loadingOverlay';
import MessageDialog from '../components/messageDialog';
import ChoosePayTypeDialog from '../components/choosePayTypeDialog';
import { get, getUser, handleImageError, getCart } from '../request';
import Input from '../components/input';
import Button from '../components/button';
import Pagination from '../components/pagination';
import Cart from '../components/cart';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import config from '../config';
import moment from 'moment';
import dataFoot from '../assets/fake-data/data-foot';
function MyDelian(props) {
    const activeIndex = 5;
    let params = useParams();
    const tabs = [{ id: 0, name: "全部" },
        { id: 1, name: "待确认" },
        { id: 5, name: "待付款" },
        { id: 2, name: "处理中" },
        { id: 3, name: "已完成" },
        { id: 4, name: "已取消" }];
    const [errorMessage, setErrorMessage] = useState("");
    const [currentTab, setCurrentTab] = useState(0);
    var parentBusinessId = 0;
    const [cartlist, setCartlist] = useState([]);
    const navigate  = useNavigate ();
    const [isShowLogin, setIsShowLogin] = useState(false);
    const [isShowChoosePayType, setShowChoosePayType] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    
    const imageRef = useRef(null); // 创建一个 ref 来引用 img 元素  
    const [isLoading, setShowLoading] = useState(false);
    var user = getUser();

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 4;
    const [totalItems, setTotalItems] = useState(1);

    const [list, setList] = useState([]);
    const [searchparams, setSearchparams] = useState({
        searchDateFrom: moment().format("YYYY-MM-DD"),
        searchDateTo: moment().format("YYYY-MM-DD"),
        searchType: 1
    });
    const handleTabChange = (tab) => {
        setCurrentTab(tab);
        getConsultation(1, searchparams.searchType, tab);
    };
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (user == null || user.userType != 1) {
            setIsShowLogin(true);
            //history.goBack();
        }
        else if (user.business.businessStatus != 0) {
            setErrorMessage("签署正式入驻合同后，可使用我的德联！");
            //history.goBack();
        }
        else {
            parentBusinessId = user.business.parentBusinessList[0].id;
            handleTabChange(0);
            getCart().then(function (response) {
                if (response.statusCode !== 200) {
                    setErrorMessage("请重新登录！");
                    setIsShowLogin(true);
                    return;
                }
                setCartlist(response.items.filter(function (c) { return c.sku; }));
            });
        }
    }, [ ]);

    const handleInputChange = (name, value) => {
        var date = moment(value).format("YYYY-MM-DD");
        setSearchparams({
            ...searchparams,
            [name]: date
        });

    };

    const handlePageChange = (page) => {
        getConsultation(page, searchparams.searchType,currentTab);
    };

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    //const currentItems = items.slice(startIndex, endIndex);



    const search = (type) => {        
        setSearchparams({
            ...searchparams,
            ["searchType"]: type
        });
        getConsultation(1, type, currentTab);
    }

    const getConsultation = (pageIndex, type, tab) => {
        var url = 'delianapi/order/query?orderType=purchase&businessId=' + parentBusinessId + '&pageIndex=' + pageIndex +
            '&pageSize=' + itemsPerPage;
        var begin = moment();
        var end = moment();
        var searchType = type ?? searchparams.searchType;
        if (searchType == 1) {
            begin = moment().subtract(1, 'months');
        } else if (searchType == 2) {
            begin = moment().subtract(3, 'months');
        } else if (searchType == 3) {
            begin = moment().subtract(1, 'years');
        } else {
            begin = moment(searchparams.searchDateFrom);
            end = moment(searchparams.searchDateTo);
        }

        var begintime = begin.format("YYYY-MM-DD");
        var endtime = end.format("YYYY-MM-DD");
        setSearchparams({
            ...searchparams,
            ["searchDateFrom"]: begintime,
            ["searchDateTo"]: endtime,
            ["searchType"]: searchType
        });

        url += '&OrderDateFrom=' + begintime;
        url += '&OrderDateTo=' + endtime;

        var curTab = tab >= 0 ? tab : currentTab;
        //全部订单 待确认 处理中 已完成 已取消
        if (curTab == 1) {
            url += '&ErpOrderStatusName=待确认';
        } else if (curTab == 2) {
            url += '&ErpOrderStatusName=处理中';
        } else if (curTab == 3) {
            url += '&ErpOrderStatusName=已完成';
        } else if (curTab == 4) {
            url += '&ErpOrderStatusName=已取消';
        } else if (curTab == 5) {
            url += '&ErpOrderStatusName=待付款';
        }
        setShowLoading(true);
        get(url).then((response) => {
            setShowLoading(false);
            if (response.statusCode == 200) {
                //recordCount = response.recordCount;
                setCurrentPage(pageIndex);
                setTotalItems(response.recordCount);
                var orders = response.items;
                calInvoiceTotalWeight(orders);               
                setList(orders);
                // enableBtnRight(); todo
            }
        });


    }
    const getColorCss = (statusName) =>{
        if (statusName == '已送达' || statusName == '部分送达') {
            return 'status-green';
        } else if (statusName == '待确认' || statusName == '出库审核' || statusName == '配货中') {
            return 'status-gray';
        } else if (statusName == '已确认' || statusName == '已出库' || statusName == '部分出库' || statusName == '已发货' || statusName == '部分发货') {
            return 'status-blue';
        }
    }

    const calInvoiceTotalWeight = (orderlist) =>{
        for (var i = orderlist.length; i--;) {
            var order = orderlist[i];
            calOrderTotalWeight(order);
        }
    }

    const calOrderTotalWeight =(order)=> {
        order.totalWeight = 0;
        order.totalQuantity = 0;
        for (var j = order.orderProductEntityList.length; j--;) {
            var product = order.orderProductEntityList[j];
            if (product.productSkuImageUrl) {
                product.productSkuImageUrl = product.productSkuImageUrl + '.small.png';
            }
            else {
                product.productSkuImageUrl = dataFoot.noimageSmall;
            }
            product.totalWeight = (parseFloat(product.weight) * parseFloat(product.quantity)).toFixed(2);
            order.totalWeight += product.totalWeight;
            order.totalQuantity += product.quantity;
        }
    }
    const handleLoginClick = () => {
        setIsShowLogin(true);
    }
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    const viewDetail = (id) => {
        navigate(config.root + "/OrderDetail?id=" + id);
    }
    const pay = (item) => {
        setCurrentItem(item);
        setShowChoosePayType(true);
    }
    const handleLocalImageError = (productId, type = 'small') => {
        // 调用公共的handleImageError函数  
        handleImageError(setErrorState, type, productId);
    };
    const setErrorState = (productId, defaultImageUrl) => {
        const oldlist = [...list];
        oldlist.forEach(function (item) {
            item.orderProductEntityList.forEach(function (product) {
                if (product.id == productId) {
                    product.productSkuImageUrl = defaultImageUrl;
                    product.error = true;
                }
            });
        });
        setList(oldlist);
    };
    return (      
        <div className="mydelian" >
            <SubHeader activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="detail" >
                    <LeftNav type={2} selectId={211} />
                    <div className="myContent">
                        <div className="title"> 我的订单 </div>
                        <div className="tab-container">
                        <ul className="tab-list">
                            {tabs.map((tab) => (
                                <li
                                    key={tab.id}
                                    className={`tab-item ${currentTab === tab.id ? 'active' : ''}`}
                                    onClick={() => handleTabChange(tab.id)}
                                >
                                    {tab.name}
                                </li>
                            ))}
                        </ul>
                        <div className="tab-content">
                                <div className="searchDiv">
                                    <div>
                                    <Button btnclass={`searchBtn ${searchparams.searchType==1 ?'active':''}`} onClick={() => search(1)} title="1个月"></Button>
                                    <Button btnclass={`searchBtn ${searchparams.searchType==2 ?'active':''}`} onClick={() => search(2)} title="2个月"></Button>
                                    <Button btnclass={`searchBtn ${searchparams.searchType==3 ?'active':''}`} onClick={() => search(3)} title="1年"></Button>
                                    </div>
                                    <div>
                                        <Input className="searchInput" inputType="date" value={searchparams.searchDateFrom}
                                        placeholder="下单开始日期 " onChange={value => handleInputChange('searchDateFrom', value) } />
                                    至
                                    <Input className="searchInput" inputType="date" value={searchparams.searchDateTo}
                                        placeholder="下单结束日期 " onChange={value => handleInputChange('searchDateTo', value)} />

                                    <Button btnclass={`searchBtn search &{searchparams.searchDateFrom || searchparams.searchDateTo?'active':''}`} onClick={() => search(4)} title="查询">
                                        </Button>
                                    </div>
                                </div>
                                <div className="listDiv">
                                    {
                                        list.length == 0 && <div className="nodata">暂无数据</div>
                                    }
                                    {
                                        list.length > 0 &&
                                            <ul>
                                            {list.map((item, index) => (
                                                <li key={item.id}>
                                                    <div className="recordNo" onClick={()=>viewDetail(item.id)}>
                                                        订单编号：
                                                        <span className="orderNo">{item.recordNo}</span>
                                                        <span className="orderDate">{moment(item.orderDate).format('YYYY-MM-DD')}</span>
                                                        
                                                        <span className="orderStatus">{item.statusName}</span>
                                                        <span className="orderDep">{item.erpDepartmentName}</span>
                                                    </div>
                                                    {
                                                        screenSize > 991 ? (
                                                            <Swiper
                                                            modules={[Navigation]}
                                                            spaceBetween={30}
                                                            slidesPerView={4}
                                                            loop={false}
                                                            navigation
                                                        >
                                                            {
                                                                item.orderProductEntityList.map((product, index) => (
                                                                    <SwiperSlide key={product.id} className="orderProduct">
                                                                        <img className="productImage" src={product.productSkuImageUrl}
                                                                            onError={() => handleLocalImageError(product.id, 'small')} />
                                                                        <div className="productPri">
                                                                            <span className={` ${product.isCanPoints ? 'blue' : 'red'} `} >
                                                                                <small >{product.isCanPoints ? '积分' : '￥'}</small>
                                                                                <span className="price" >{product.unitPrice.toFixed(2)}</span>
                                                                            </span>
                                                                            ×<span >{product.quantity}</span>
                                                                        </div>
                                                                        <div> {product.skuName}</div>
                                                                        <div> {product.productSkuName}</div>
                                                                    </SwiperSlide>
                                                                ))
                                                            }
                                                            </Swiper>) : (
                                                                <div className="orderProductList">
                                                                    {
                                                                        item.orderProductEntityList.map((product, index) => (
                                                                            <div className="orderProduct" key={product.id}>
                                                                                <img className="productImage" src={product.productSkuImageUrl}
                                                                                    onError={() => handleLocalImageError(product.id, 'small')} />
                                                                                <div className="productName">                                                                                    
                                                                                    <div> {product.productSkuName}</div>
                                                                                    <div className="skuName"> {product.skuName}</div>
                                                                                </div>
                                                                                <div className="productPri">
                                                                                    <div className={` ${product.isCanPoints ? 'blue' : 'red'} `} >
                                                                                        <small >{product.isCanPoints ? '积分' : '￥'}</small>
                                                                                        <span className="price" >{product.unitPrice.toFixed(2)}</span>
                                                                                    </div>
                                                                                    ×<span >{product.quantity}</span>
                                                                                </div>                                                                                
                                                                            </div>
                                                                        ))
                                                                    }
                                                        </div>
                                                                )
                                                    }
                                                    
                                                    <div className="totalPrice">
                                                                                                               
                                                        共计 <span className="red" >{item.totalQuantity}</span> 件产品 合计：
                                                        <span className="red">￥<span className="fs-2" >{item.totalPrice}</span></span>
                                                        {
                                                            item.allPointsDeduction > 0 &&
                                                            <div className="blue">
                                                                + 积分<span className="fs-2" >{item.allPointsDeduction}</span>
                                                            </div>
                                                        }
                                                        {
                                                            item.orderStatus == 1 && item.receivedAmount == 0 &&
                                                            <Link className="btnPay" onClick={()=>pay(item)}>结算</Link>
                                                        }
                                                    </div>

                                                </li>
                                            ))}
                                        </ul>
                                    }                                    
                                    {
                                        list.length > 0 && <Pagination
                                            totalItems={totalItems}
                                            itemsPerPage={itemsPerPage}
                                            onPageChange={handlePageChange}
                                        />
                                    }
                                </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                cartlist &&
                <Cart num={cartlist.length} />
            }
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
            <MessageDialog message={ errorMessage} onCancel={() => {
                setErrorMessage("");
                navigate(-1);
            }} />            
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
            <ChoosePayTypeDialog initItem={currentItem} isShow={isShowChoosePayType} onCancel={() => {
                setShowChoosePayType(false);
            }}  />
        </div>
          
    );
}

export default MyDelian;